import { Field } from 'redux-form'
import { renderers, validations } from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import React from 'react'

export const OrganizationDisplay = () => {
  return (
    <>
      <Field
        label="Organization"
        name="organization"
        component={renderers.renderHiddenField}
        type="text"
      />
      <Field
        label="Organization"
        validate={[validations.required]}
        name="organization_suggestions"
        actualFieldName="organization"
        endpoint="organizations"
        renderSuggestion={(organization) => {
          return (
            <ReactBootstrap.Col className={'ps-1'}>
              <h6>
                {organization.code}-<small>{organization.name}</small>
              </h6>
            </ReactBootstrap.Col>
          )
        }}
        component={renderers.EaseOnAutoSuggest}
        type="text"
      />
    </>
  )
}
